import Config from "../config";


const zipLookup = (zipCode: string) => {
    return fetch(`https://maps.googleapis.com/maps/api/geocode/json?components=postal_code:${zipCode}&key=${Config.ZIP_CODE_API_KEY
        }`)
        .then(response => response.json())
        .then(data => {
            if (data.status === "ZERO_RESULTS") {
                return Promise.reject("Please enter valid US/Canada/UK Zipcode")
            }
            let obj1 = data.results[0].address_components.find((i: any) => i.types[0] === "postal_code")
            let obj2 =
                data.results[0].address_components.find((i: any) => i.types[0] === "locality") ||
                data.results[0].address_components.find((i: any) => i.types[0] === "postal_town") ||
                data.results[0].address_components.find((i: any) => i.types[0] === "neighborhood")
            let obj3 = data.results[0].address_components.find((i: any) => i.types[0] === "administrative_area_level_1")
            let obj4 = data.results[0].address_components.find((i: any) => i.types[0] === "country")
            if (obj4?.short_name !== "US" && obj4?.short_name !== "CA" && obj4?.short_name !== "GB") {
                return Promise.reject("Please enter valid US/Canada/UK Zipcode")
            }
            return { ZipCode: obj1?.long_name, City: obj2?.long_name, State: obj3?.short_name, Country: obj4?.short_name }
        })
}

export const ExternalServices = {
    zipLookup
}
